import { NavLink } from 'react-router-dom';
import './adminNavigation.css';
import StatusButtons, { IStatusButtonsProps } from '../StatusButtons/StatusButtons';

function AdminNavigation({
  filterButtonDate,
  isUsersPage,
  isAutoparksPage,
  onAddClick,
}: {
  filterButtonDate?: IStatusButtonsProps['filterButtonDate'];
  isUsersPage?: boolean;
  isAutoparksPage?: boolean;
  onAddClick?: () => void;
}) {
  return (
    <>
      <nav className="admin-navigation">
        <div className="admin-nav-tabs">
          <NavLink
            to="/account/admin/users"
            className={({ isActive }) => (isActive ? 'admin-nav-tab admin-nav-tab--active' : 'admin-nav-tab')}
          >
            Пользователи
          </NavLink>
          <NavLink
            to="/account/admin/autoparks"
            className={({ isActive }) => (isActive ? 'admin-nav-tab admin-nav-tab--active' : 'admin-nav-tab')}
          >
            Автопарки
          </NavLink>
          <NavLink
            to="/account/admin/waybills"
            className={({ isActive }) => (isActive ? 'admin-nav-tab admin-nav-tab--active' : 'admin-nav-tab')}
          >
            Путевые листы
          </NavLink>
        </div>
        {isUsersPage && filterButtonDate && <StatusButtons filterButtonDate={filterButtonDate} />}
        {isAutoparksPage && (
          <button className="admin-add-button" onClick={onAddClick}>
            Добавить
            <div className="admin-add-button__icon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 3V13M3 8H13" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </button>
        )}
      </nav>
    </>
  );
}

export default AdminNavigation;
